/* @jsxImportSource react */

/**
 * EnergyEfficiencyIcon component.
 *
 * Styling has to be completely managed by the parent component and passed via `className` param.
 */
export const NewEnergyEfficiencyFlagIcon = ({ className }: { className: string }) => (
  <svg
    className={className}
    id="Ebene_1"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 35 20"
  >
    <path fill="currentColor" d="M8.9,0h26.1v20H8.9L0,9.6,8.9,0Z" />
    <path fill="#ffffff" d="M34.6,0h-8v20h8V0Z" />
    <path d="M30.6,16.5h1v.6c0,.1-.3.2-.5.3s-.3.1-.5.1c-.3,0-.6-.1-.8-.4s-.4-.8-.4-1.4,0-1,.3-1.3.5-.4.9-.4.4.1.6.2.3.3.3.6l.8-.2c0-.5-.3-.8-.6-1.1s-.7-.4-1.2-.4-.8.1-1.1.3-.4.6-.6,1-.3.8-.3,1.4,0,1,.3,1.4.4.7.7.9.7.3,1.1.3.7-.1,1-.2.6-.3.8-.5v-2h-1.8v.8ZM29.7,5.4h1.6l.4,1.1h.9l-1.6-5h-.9l-1.6,5h.9l.3-1.1ZM30.6,2.7l.6,1.9h-1.2s.6-1.9.6-1.9ZM32.1,8.9l-1.6-1.4-1.7,1.4.6.6.7-.6v3.3h.8v-3.3l.6.6.6-.6Z" />
    <path d="M9,20h26.1V0H9L0,9.6s9,10.4,9,10.4ZM34.6,19.5H9.3L.7,9.6,9.3.5h25.3v19Z" />
  </svg>
);

NewEnergyEfficiencyFlagIcon.displayName = 'EnergyEfficiencyIcon';
